import LottieView from "lottie-react-native";
import { View, useWindowDimensions } from "react-native";

const CANVAS_W = 360;
const CANVAS_H = 560;

export function FullPageLoadingScreen() {
  const { width } = useWindowDimensions();
  const animHeight = width * (CANVAS_H / CANVAS_W);

  return (
    <View className="bg-background flex-1 items-center justify-center">
      <LottieView
        source={require("@/assets/animations/loading.json")}
        autoPlay
        loop
        style={{ width, height: animHeight }}
      />
    </View>
  );
}
